import { SoftphoneIntegrationEnum, TimeEnum } from '@lib/enums';

import type { AppConfig } from '@config';

export const LocalPaymentConfig = {
  apiKeyGoogleMaps: 'AIzaSyB6aRjr-BiiOP2tPG4OLlcLmDl73NfhzXw',
  appEnv: 'local',
  azure: {
    authority: 'https://login.microsoftonline.com/daae7bc1-c893-46c4-8df4-4464a9a6f43e',
    clientId: '1ffc00d1-10a4-4e76-8840-912239b05fee',
    tenantId: 'daae7bc1-c893-46c4-8df4-4464a9a6f43e',
  },
  gatewayUrl: 'https://end-gateway-kitt-dev.azurewebsites.net/api/v1',
  paymentUrl: 'http://localhost:5173/',
  pcrsPortalUrl: 'https://uat-beta-auto.pcrsdev.com/pcmi.web.portal.core',
  softphoneIntegration: {
    client: SoftphoneIntegrationEnum.Contacts,
    enabled: false,
    enableDebugLogs: false,
  },
  defaultApiTimeout: TimeEnum.ThirtySeconds,
  sentryIngestionEndpoint: '',
} satisfies AppConfig;
